module.exports = __webpack_public_path__ + "static/media/background5.45b9ff64.jpg";